import { render } from "./MoleculeTabs.vue?vue&type=template&id=52995676&ts=true"
import script from "./MoleculeTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeTabs.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/molecules/MoleculeTabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52995676"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52995676', __exports__)) {
    api.reload('52995676', __exports__)
  }
  
  module.hot.accept("./MoleculeTabs.vue?vue&type=template&id=52995676&ts=true", () => {
    api.rerender('52995676', render)
  })

}


export default __exports__